"use strict";
//
// Copyright (c) Microsoft. All rights reserved.
// Licensed under the MIT license. See LICENSE.md file in the project root for full license information.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnUnknownAction = void 0;
/**
 * An enum that defines actions that can be taken on unknown language detection
 */
var OnUnknownAction;
(function (OnUnknownAction) {
    OnUnknownAction["RecognizeWithDefaultLanguage"] = "RecognizeWithDefaultLanguage";
    OnUnknownAction["None"] = "None";
})(OnUnknownAction = exports.OnUnknownAction || (exports.OnUnknownAction = {}));

//# sourceMappingURL=OnUnknown.js.map
